import { Account } from '@/models/Account'

const mutations = {
  /** ログイン時のアカウント情報取得処理 */
  INITIALIZE(state, { account }) {
    state.account = new Account(account)
  },
  INITIALIZE_SYSTEM_OWNER(state, { systemOwner }) {
    state.systemOwner = systemOwner
  },
  UPDATE_NAME(state, name) {
    state.account.name = name
  },
  UPDATE_EMAIL(state, email) {
    state.account.email = email
  },
  SET_SEARCH_RESULT(state, obj) {
    state.searchResult = obj
  },
}

export default mutations
